export default __webpack_public_path__ + "static/media/email.9ee3eab3.svg";